import {
  getCalenders,
  getSchedules,
  getRescheduleCalenders,
  getUser,
  resConfirm,
  resAbort,
  resCancel,
  resReschedule,
  invConfirm,
  invReject,
  ticketAbort,
  queueRedeem,
  removeSubUser,
  ticketConfirm,
  getMpEventList,
  getFootprintTaskListToday,
  getFootprintTaskListAll,
  getFootprintServiceTime,
  getFootprintCreateQRCodeStr,
  getFootprintAddTaskBranchFinish,
  getSpaceTaskListAll,
} from '@/api'

const apiCaller = (api, payload, onSuccess) => {
  return new Promise((resolve, reject) => {
    api(payload)
      .then((data) => {
        console.log('action got data', data)
        onSuccess(data)
        resolve(data)
      })
      .catch((err) => {
        console.log('err', err)
        reject(err)
      })
      .finally((res) => {
        console.log('finally', res)
      })
  })
}

export const GetCalenders = ({ commit, state }) => {
  return apiCaller(getCalenders, {}, (data) => {
    commit('setCalenders', data)
  })
}

export const GetRescheduleCalenders = ({ commit, state }, resId) => {
  return apiCaller(getRescheduleCalenders, resId, (data) => {
    commit('setCalenders', data)
  })
}

export const GetSchedules = ({ commit, state }, payload) => {
  return apiCaller(getSchedules, payload, (date) => {
    commit('setSchedules', date)
  })
}

export const GetUser = ({ commit, state }, userId) => {
  return apiCaller(getUser, userId, (data) => {
    commit('updateUserInfo', data)
  })
}

export const ResConfirm = ({ commit, state }, resId) => {
  return apiCaller(resConfirm, resId, (data) => { })
}

export const ResAbort = ({ commit, state }, resId) => {
  return apiCaller(resAbort, resId, (data) => { })
}

export const ResCancel = ({ commit, state }, payload) => {
  return apiCaller(resCancel, payload, (data) => { })
}

export const ResReschedule = ({ commit, state }, payload) => {
  return apiCaller(resReschedule, payload, (data) => { })
}

export const InvConfirm = ({ commit, state }, payload) => {
  return apiCaller(invConfirm, payload, (data) => { })
}

export const InvReject = ({ commit, state }, invCode) => {
  return apiCaller(invReject, invCode, (data) => { })
}

export const TicketAbort = ({ commit, state }, orderId) => {
  return apiCaller(ticketAbort, orderId, (data) => { })
}

export const QueueRedeem = ({ commit, state }, payload) => {
  return apiCaller(queueRedeem, payload, (data) => { })
}

export const RemoveSubUser = ({ commit, state }, payload) => {
  return apiCaller(removeSubUser, payload, () => { })
}

export const TicketConfirm = ({ commit, state }, payload) => {
  return apiCaller(ticketConfirm, payload, () => {
    console.log('ticket confirmed')
  })
}

export const GetMpEventList = ({ commit, state }) => {
  return apiCaller(getMpEventList, {}, (data) => {
    commit('setMpEventList', data)
  })
}

export const GetFootprintTaskListToday = ({ commit, state }, payload) => {
  return apiCaller(getFootprintTaskListToday, payload, (data) => {
    commit('setFootprintTaskListToday', data)
  })
}

export const GetFootprintTaskListAll = ({ commit, state }, payload) => {
  return apiCaller(getFootprintTaskListAll, payload, (data) => {
    // commit('setFootprintTaskListAll', data)
  })
}

export const GetFootprintServiceTime = ({ commit, state }, payload) => {
  return apiCaller(getFootprintServiceTime, payload, (data) => {
    commit('setFootprintServiceTime', data.data.split(' ')[0])
  })
}

export const GetFootprintCreateQRCodeStr = ({ commit, state }, payload) => {
  return apiCaller(getFootprintCreateQRCodeStr, payload, (data) => {
    commit('setFootprintCreateQRCodeStr', data)
  })
}

export const GetFootprintAddTaskBranchFinish = ({ commit, state }, payload) => {
  return apiCaller(getFootprintAddTaskBranchFinish, payload, (data) => {
    // TODO 需要手动同步支线任务？
    // commit('setFootprintCreateQRCodeStr', data)
  })
}

export const GetSpaceTaskListAll = ({ commit, state }, payload) => {
  return apiCaller(getSpaceTaskListAll, payload, (data) => {
    // commit('setFootprintTaskListAll', data)
  })
}
